import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=544e933a"
import script from "./Consents.vue?vue&type=script&lang=js"
export * from "./Consents.vue?vue&type=script&lang=js"
import style0 from "./Consents.vue?vue&type=style&index=0&id=544e933a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports